type DesignPartnerGraphicProps = {
  compact?: boolean;
  clean?: boolean;
};

const sources = [
  { icon: 'bi-file-earmark-text', label: 'Equipment manuals' },
  { icon: 'bi-wrench-adjustable', label: 'Service history' },
  { icon: 'bi-journal-text', label: 'Troubleshooting notes' },
  { icon: 'bi-people', label: 'Expert knowledge' },
];

export function DesignPartnerGraphic({ compact = false, clean = false }: DesignPartnerGraphicProps) {
  return (
    <div className={`r42-dp-graphic${compact ? ' r42-dp-graphic--compact' : ''}${clean ? ' r42-dp-graphic--clean' : ''}`} aria-hidden="true">
      <div className="r42-dp-graphic-sources">
        {sources.map((source) => (
          <div className="r42-dp-source-card" key={source.label}>
            <i className={`bi ${source.icon}`} />
            <span>{source.label}</span>
          </div>
        ))}
      </div>

      <div className="r42-dp-knowledge-flow">
        <svg className="r42-dp-flow-lines" viewBox="0 0 180 330" preserveAspectRatio="none">
          <path d="M0 56 C48 56 47 165 88 165" />
          <path d="M0 129 C47 129 55 165 88 165" />
          <path d="M0 202 C47 202 55 165 88 165" />
          <path d="M0 275 C48 275 47 165 88 165" />
          <path className="r42-dp-flow-lines-output" d="M118 165 C140 165 152 165 180 165" />
          <circle cx="88" cy="165" r="4" />
          <circle cx="118" cy="165" r="4" />
        </svg>

        <div className="r42-dp-knowledge-hub">
          <span className="r42-dp-knowledge-icon"><i className="bi bi-diagram-3" /></span>
          <strong>Machine Knowledge</strong>
          <small>Evidence and experience, connected around one machine.</small>
        </div>
      </div>

      <div className="r42-dp-intelligence-card">
        <strong>Machine Intelligence</strong>
        <p>Turn connected machine knowledge into something your team can use in the flow of real work.</p>
        <ul>
          <li><i className="bi bi-check2" /> Grounded answers</li>
          <li><i className="bi bi-check2" /> Faster investigations</li>
          <li><i className="bi bi-check2" /> Knowledge that persists</li>
        </ul>
      </div>
    </div>
  );
}
